import React from 'react'
import { chatType } from '../testOpsGenie'
import Table from './table'
import Md from './md'
import Loader from '../../loader'

interface MdProps {
    chat: chatType
}

const GenieResponse: React.FC<MdProps> = ({ chat }) => {
    const getAIResponse = (chat: chatType) => {
        if (!chat.success) {
            return <Loader />
        }

        if (chat?.response?.task_response == null) {
            return <Md text={'⚠️ **Failure to Generate Response**\n\nPlease log in to the Insights Copilot portal:\n\n➡️ https://insights-copilot.ab-inbev.com/\n\nor contact **TestOps support team**.'} />
        }

        const engineResponse: any = chat.response.task_response
        const ans: any = engineResponse.final_answer
        return (
            <div className="w-full flex flex-col gap-4">
                {ans && (
                    <div>
                        <Md text={ans} />
                    </div>
                )}

                <Table engineResponse={engineResponse} />

                {/* <div className="flex items-center gap-4 text-gray-500">
                    <Volume2 className="w-4 h-4 cursor-pointer hover:text-gray-800" />
                    <Copy className="w-4 h-4 cursor-pointer hover:text-gray-800" />
                    <ThumbsUp className="w-4 h-4 cursor-pointer hover:text-gray-800" />
                    <ThumbsDown className="w-4 h-4 cursor-pointer hover:text-gray-800" />
                </div> */}
            </div>
        )
    }

    return (
        <div className="flex items-start gap-2 w-full font-sans">
            <div className="flex-shrink-0">
                <img src="/assets/images/Genie.svg" alt="User Avatar" className="w-5 h-5 rounded-full" />
            </div>
            <div className="w-full">
                {getAIResponse(chat)}
                <div className="text-[11px] text-gray-300 mt-1">{chat?.createdAt?.fromNow()}</div>
            </div>
        </div>
    )
}

export default GenieResponse
